<template>
  <div class="detail-container">
    <detail-header />
    <detail-base-info />
    <detail-things-like></detail-things-like>
    <question-list />
    <photo-list />
  </div>
</template>

<script>
// 页面标题
import DetailHeader from './component/detail-header'
// 基本信息
import DetailBaseInfo from './component/detail-base-info'
// 兴趣
import DetailThingsLike from './component/detail-things-like'
// 问题列表
import QuestionList from './component/detail-question-list'
// 相册列表
import PhotoList from './component/detail-photo-list'
import {userFieldMap} from "@/views/member/const";
import DefaultUserLogo from "@/assets/default_user.png";
export default {
  name: 'UserDetail',
  components: {
    DetailHeader,
    DetailBaseInfo,
    DetailThingsLike,
    QuestionList,
    PhotoList
  },
  data() {
    return {
      userId:"",
      logoDeafult: DefaultUserLogo,
      cardTitle: '基本信息'
    }
  },
  created(){
    // const mobile = this.$route.query.mobile;
    const {userId} = this.$route.query
    this.userId = {userId}
    this.$store.dispatch('user/getUserInfo', { userId }).then((res) => {
    })
  }
}
</script>

<style lang="scss" scoped>
.detail-container {
  padding: 10px;
  margin-top: 20px;
}
</style>
